import {
  designedCovers,
  type DesignedCoverId,
} from '@mixtiles/web-backend-shared'
import { getCloudinaryFetchBaseUrl } from 'services/CloudinaryService'
import { type SerializedCover } from 'services/PhotoBook/photoBookDTO.types'
import { type Cover } from 'components/PhotoBook/PhotoBookProvider/PhotoBook.types'
import { type RemotePhoto } from 'components/PhotoBank/PhotoBank.types'

const DESIGNED_COVER_PREVIEW_WIDTH = 600

// Designed covers ship as SVG, which Jimp cannot decode — the preview consumer
// reads this url into Jimp to composite the cover, so an SVG yields no image at
// all. Cloudinary rasterizes it on the way through, and the svg paints its own
// background, so there is nothing to composite behind it. It also spares the
// books flow, whose url reaches Braze directly, from mail clients that drop SVG.
function getDesignedCoverPreviewUrl(
  designedCoverId: string | undefined
): string | undefined {
  const designedCover = designedCovers[designedCoverId as DesignedCoverId]
  // A cover retired from the catalog still round-trips on books that used it.
  if (!designedCover) {
    return undefined
  }
  return `${getCloudinaryFetchBaseUrl()}/f_jpg,w_${DESIGNED_COVER_PREVIEW_WIDTH}/${
    designedCover.frontUrl
  }`
}

export function getCoverPreviewUrl(cover: SerializedCover): string | undefined {
  switch (cover.type) {
    case 'designed':
      return getDesignedCoverPreviewUrl(cover.designedCoverId)
    case 'ai-generated':
      return cover.aiGeneratedCoverUrl
    case 'photo':
      return cover.photo?.url
  }
}

export function getStoredCoverPreviewUrl(
  cover: Cover,
  remotePhotoByUid: Record<string, RemotePhoto>
): string | undefined {
  switch (cover.type) {
    case 'designed':
      return getDesignedCoverPreviewUrl(cover.designedCoverId)
    case 'ai-generated':
      return cover.coverUrl
    case 'photo':
      return remotePhotoByUid[cover.photo.uid]?.originalUrl
  }
}
